export const T = {
  en_GB: {
    postComment: "Post comment",
    back: "Back",
    remove: "Remove",
    title: "Support",
    subtitle: "Submit issues and get help",
    newTicket: "New ticket",
    titleLabel: "Title",
    titlePlaceholder: "Brief summary",
    descLabel: "Description",
    descPlaceholder: "Describe the problem...",
    screenshot: "Screenshot",
    screenshotHint: "Drop an image here, or click to choose (max 2MB)",
    refresh: "Refresh",
    removeImage: "Remove",
    attachments: "Attachments",
    attachContext: "Attach from this page",
    openAttachment: "Open",
    cancel: "Cancel",
    submit: "Submit",
    submitting: "Submitting...",
    noTickets: "No support tickets yet",
    loading: "Loading...",
    comments: "Comments",
    addComment: "Add a comment...",
    noComments: "No comments yet",
    confirmDelete: "Delete this ticket?",
    confirmDeleteComment: "Delete this comment?",
    confirmDeleteAttachment: "Remove this attachment?",
    delete: "Delete",
    status: "Status",
    close: "Close ticket",
    reopen: "Reopen ticket",
    filterAll: "All",
    filterAllTenants: "All tenants",
    browserInfo: "Diagnostics",
    diagnosticsHint: "Includes console + network log and browser info",
    showDetails: "Show details",
    hideDetails: "Hide details",
    statusLabel: { open: "Open", closed: "Closed" },
    attachmentType: { chat_thread: "Chat thread", flow_instance: "Flow instance" },
    loadFailed: "Failed to load tickets",
    selectImage: "Please select an image",
    imageTooLarge: "Image must be < 2MB",
    uploadFailed: "Failed to upload image",
    titleRequired: "Title is required",
    descriptionRequired: "Description is required",
    submitFailed: "Failed to submit",
  },
  nb_NO: {
    postComment: "Publiser kommentar",
    back: "Tilbake",
    remove: "Fjern",
    title: "Support",
    subtitle: "Send inn problemer, få hjelp",
    newTicket: "Nytt support-ticket",
    titleLabel: "Tittel",
    titlePlaceholder: "Kort sammendrag",
    descLabel: "Beskrivelse",
    descPlaceholder: "Beskriv problemet...",
    screenshot: "Skjermbilde",
    screenshotHint: "Slipp et bilde her, eller klikk for å velge (maks 2MB)",
    refresh: "Oppdater",
    removeImage: "Fjern",
    attachments: "Vedlegg",
    attachContext: "Vedlegg fra konteksten",
    openAttachment: "Åpne",
    cancel: "Avbryt",
    submit: "Send inn",
    submitting: "Sender...",
    noTickets: "Ingen support-tickets ennå",
    loading: "Laster...",
    comments: "Kommentarer",
    addComment: "Legg til kommentar...",
    noComments: "Ingen kommentarer ennå",
    confirmDelete: "Slette dette ticketet?",
    confirmDeleteComment: "Slette denne kommentaren?",
    confirmDeleteAttachment: "Fjerne dette vedlegget?",
    delete: "Slett",
    status: "Status",
    close: "Lukk ticket",
    reopen: "Gjenåpne ticket",
    filterAll: "Alle",
    filterAllTenants: "Alle tenants",
    browserInfo: "Diagnostikk",
    diagnosticsHint: "Inkluderer konsoll- og nettverkslogg samt nettleserinfo",
    showDetails: "Vis detaljer",
    hideDetails: "Skjul detaljer",
    statusLabel: { open: "Åpen", closed: "Lukket" },
    attachmentType: { chat_thread: "Chat-tråd", flow_instance: "Flytinstans" },
    loadFailed: "Kunne ikke laste support-tickets",
    selectImage: "Velg et bilde",
    imageTooLarge: "Bildet må være under 2MB",
    uploadFailed: "Kunne ikke laste opp bildet",
    titleRequired: "Tittel er påkrevd",
    descriptionRequired: "Beskrivelse er påkrevd",
    submitFailed: "Kunne ikke sende inn",
  },
} as const;
